import React, { useState } from "react";
import Axios from "axios"; // Make sure Axios is installed
import { useTranslation } from "react-i18next";
import { baseURL, CONTACT } from "../../../Api/Api";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { Alert } from "@mui/material"; // Import Alert from MUI

function ContactSection() {
  const { t, i18n } = useTranslation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [alert, setAlert] = useState(null);
  const [alertVisible, setAlertVisible] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    setAlert(null);

    try {
      const response = await Axios.post(`${baseURL}/${CONTACT}`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        setAlert({ type: "success", message: t("successMessage") }); // Use translated message
        setFormData({ name: "", email: "", subject: "", message: "" }); // Clear form
      } else {
        setAlert({ type: "error", message: t("errorMessage") });
      }
    } catch (error) {
      setAlert({
        type: "error",
        message: "Failed to send message. Please try again later.",
      });
    }

    setAlertVisible(true);
    setTimeout(() => setAlertVisible(false), 4000); // Hide after 2 seconds
    setLoading(false);
  };

  return (
    <>
      <section id="contact" className="contact section">
        <div className="container">
          {alert && alertVisible && (
            <Alert
              severity={alert.type}
              onClose={() => setAlertVisible(false)}
              sx={{
                transition: "opacity 1s ease-out",
                opacity: alertVisible ? 1 : 0,
                marginBottom: "10px",
              }}
            >
              {alert.message}
            </Alert>
          )}
          <div className="row gy-4 white-font">
            <div className="col-md-6">
              <div className="info-item d-flex align-items-center">
                <i className="icon bi bi-geo-alt flex-shrink-0 ms-2" />
                <div>
                  <h3 className="text-white">{t("address")}</h3>
                  <p className="text-white">Turkey / Istanbul</p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="info-item d-flex align-items-center">
                <i className="icon bi bi-telephone flex-shrink-0 ms-2" />
                <div>
                  <h3 className="text-white">{t("callMe")}</h3>
                  <p
                    className="text-white"
                    style={{
                      direction: i18n.language === "ar" ? "ltr" : "ltr",
                    }}
                  >
                    +90 538 958 70 88
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="info-item d-flex align-items-center">
                <i className="icon bi bi-envelope flex-shrink-0 ms-2" />
                <div>
                  <h3 className="text-white">{t("emailUs")}</h3>
                  <p className="text-white">mohammad98.sn@gmail.com</p>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="info-item d-flex align-items-center">
                <i className="icon bi bi-share flex-shrink-0 ms-2" />
                <div>
                  <h3 className="text-white">{t("socialProfiles")}</h3>
                  <div className="social-links">
                    <Link
                      to="https://www.facebook.com/mohammad.sn.31"
                      target="_blank"
                    >
                      <i className="bi bi-facebook" />
                    </Link>
                    <Link to="https://wa.me/+905389587088" target="_blank">
                      <i className="bi bi-whatsapp" />
                    </Link>
                    <Link to="https://x.com/mohammadsn3" target="_blank">
                      <i className="bi bi-twitter-x" />
                    </Link>
                    <Link
                      to="https://www.instagram.com/mohammad.sn98/"
                      target="_blank"
                    >
                      <i className="bi bi-instagram" />
                    </Link>
                    <Link
                      to="https://www.youtube.com/@mohammadsn932"
                      target="_blank"
                    >
                      <i className="bi bi-youtube" />
                    </Link>
                    <Link
                      to="https://www.linkedin.com/in/mohamad-snobar-3710b219a/"
                      target="_blank"
                    >
                      <i className="bi bi-linkedin" />
                    </Link>
                    <Link
                      to="https://www.behance.net/mohammadsnGD"
                      target="_blank"
                    >
                      <i className="bi bi-behance" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <form onSubmit={handleSubmit} className="php-email-form">
            <div className="row gy-4">
              <div className="col-md-6">
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  placeholder={t("nameLabel")}
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  placeholder={t("emailLabel")}
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-12">
                <input
                  type="text"
                  className="form-control"
                  name="subject"
                  placeholder={t("subjectLabel")}
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-12">
                <textarea
                  className="form-control"
                  name="message"
                  rows={6}
                  placeholder={t("messageLabel")}
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-12 text-center">
                {loading && <div className="loading">Loading...</div>}
                <Button type="submit" disabled={loading}>
                  {i18n.language === "ar" ? "إرسال" : "Send Message"}
                </Button>
              </div>
            </div>
          </form>
        </div>
      </section>
    </>
  );
}

export default ContactSection;
